/*
 *
 * Category reducer
 *
 */

export const Types = {
  // Insere uma categoria
  
  GET_INSERT_REQUEST: 'category/GET_INSERT_REQUEST',
  GET_INSERT_SUCCESS: 'category/GET_INSERT_SUCCESS',
  GET_INSERT_FAILURE: 'category/GET_INSERT_FAILURE',
};

export const initialState = {
  // Insere uma categoria
  categoryInsertLoading: false,
  categoryInsertError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_INSERT_REQUEST:
      return {
        ...state,
        categoryInsertLoading: true,
        categoryInsertError: null,
      };
    case Types.GET_INSERT_SUCCESS:
      return {
        ...state,
        categoryInsertLoading: false,
        categoryInsertError: null,
      };
    case Types.GET_INSERT_FAILURE:
      return {
        ...state,
        categoryInsertLoading: false,
        categoryInsertError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Insere uma categoria
  getCategoryInsertRequest: ({
    category_father,
    description,
    name,
    order_position,
    image_data,
  }) => ({
    type: Types.GET_INSERT_REQUEST,
    payload: { category_father, description, name, order_position, image_data },
  }),
  getCategoryInsertSuccess: () => ({
    type: Types.GET_INSERT_SUCCESS,
  }),
  getCategoryInsertFailure: error => ({
    type: Types.GET_INSERT_FAILURE,
    payload: error,
  }),
};
